import React, { useState, useEffect, useMemo } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, orderBy, query } from 'firebase/firestore';
import { Award } from 'lucide-react';
import '../../styles/RankDetails.css';
import CarruselPlanCarrera from '../../components/CarruselPlanCarrera';

// Mientras esté en true, los usuarios solo ven el aviso de actualización. En false vuelve el contenido.
const SECCION_EN_ACTUALIZACION = true;

const RankDetails = ({ profileData }) => {
    const [ranks, setRanks] = useState([]);
    const [loading, setLoading] = useState(true);
    const [activeTab, setActiveTab] = useState('info');
    const userPoints = profileData?.points || 0;

    useEffect(() => {
        if (SECCION_EN_ACTUALIZACION) return;
        const fetchRanks = async () => {
            try {
                const q = query(collection(db, 'ranks'), orderBy('pointsRequired', 'asc'));
                const querySnapshot = await getDocs(q);
                const ranksList = querySnapshot.docs.map(doc => ({ 
                    id: doc.id, 
                    ...doc.data() 
                }));
                setRanks(ranksList);
            } catch (error) {
                console.error("Error al obtener los rangos:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchRanks();
    }, []);

    // Lógica para rango actual y siguiente
    const { currentRank, nextRank, progress } = useMemo(() => {
        let current = null;
        let next = null;
        for (let i = 0; i < ranks.length; i++) {
            if (userPoints >= ranks[i].pointsRequired) {
                current = ranks[i];
            } else {
                next = ranks[i];
                break;
            }
        }
        if (!next && current) return { currentRank: current, nextRank: null, progress: 100 };
        const minPoints = current ? current.pointsRequired : 0;
        const maxPoints = next ? next.pointsRequired : 1;
        const range = maxPoints - minPoints;
        const currentProgress = userPoints - minPoints;
        const percentage = Math.min(Math.max((currentProgress / range) * 100, 0), 100);
        return { currentRank: current, nextRank: next, progress: percentage };
    }, [ranks, userPoints]);

    if (SECCION_EN_ACTUALIZACION) {
        return (
            <div className="rank-details-container">
                <header className="rank-details-header">
                    <h1>Recorrido Gerencial</h1>
                    <p>Estamos actualizando esta sección. Muy pronto estará disponible.</p>
                </header>
            </div>
        );
    }

    if (loading) return <div className="loading-view">Cargando Recorrido Gerencial...</div>;

    return (
        <div className="rank-details-container">
            <header className="rank-details-header">
                <h1>Recorrido Gerencial</h1>
                <p>Consulta tu progreso, requisitos y premios de cada rango.</p>
            </header>

            {/* Tabs */}
            <div className="rank-tabs">
                <button
                    className={activeTab === 'info' ? 'tab-btn active' : 'tab-btn'}
                    onClick={() => setActiveTab('info')}
                >¿Qué es el Recorrido Gerencial?</button>
                <button
                    className={activeTab === 'personal' ? 'tab-btn active' : 'tab-btn'}
                    onClick={() => setActiveTab('personal')}
                >Mi Progreso</button>
            </div>

            {/* Tab Content */}
            {activeTab === 'info' && (
                <section className="plan-info-tab">
                    <CarruselPlanCarrera />
                </section>
            )}

            {activeTab === 'personal' && (
                <section className="user-rank-tab">
                    <div className="user-rank-summary">
                        <Award size={40} />
                        <div>
                            <h2>Tu Rango Actual: {currentRank?.name || 'Sin rango'}</h2>
                            <p>Puntos: {userPoints}</p>
                            <div className="progress-bar">
                                <div style={{ width: `${progress}%` }} />
                            </div>
                            <p>
                                {nextRank
                                    ? `Te faltan ${nextRank.pointsRequired - userPoints} puntos para ${nextRank.name}`
                                    : '¡Has alcanzado el rango máximo!'}
                            </p>
                        </div>
                    </div>
                </section>
            )}
        </div>
    );
};

export default RankDetails;